export function getKeyByValue(enumObj: any, value: any): string {
    return Object.keys(enumObj).find((key) => enumObj[key] === value);
}